import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcBaselineLaptop = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.8333 14.2501C16.7042 14.2501 17.4167 13.5376 17.4167 12.6667V4.75008C17.4167 3.87925 16.7042 3.16675 15.8333 3.16675H3.16667C2.29583 3.16675 1.58333 3.87925 1.58333 4.75008V12.6667C1.58333 13.5376 2.29583 14.2501 3.16667 14.2501H0V15.8334H19V14.2501H15.8333ZM3.16667 4.75008H15.8333V12.6667H3.16667V4.75008Z",
		fill: "#FFBF00"
	})
});
export default SvgIcBaselineLaptop;
